import React, { Component } from 'react';
import lang from '../../../lang/index';

export default class PaytmNavBar extends Component {
    constructor(props){
        super(props);
    }

    render() {
        return (
            <nav className="recharge-nav">
                <div className="nav-top">
                    <div className="expand" onClick={this.props.toggleExpand('expand')}/>
                    <div className="navs" style={{height: this.props.expand ? window.innerHeight : 0}}>
                        <ul>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <a href="http://h5.upliveapp.com/zencms/5bced7af584fbb6c0aab550d.html">About us</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <a href="http://h5.upliveapp.com/zencms/5bd011b7584fbb6c0aab5513.html">Refund & Cancellation</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <a href="http://h5.upliveapp.com/zencms/5bcef6eb584fbb6c0aab550e.html">Contact us</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <a href="http://h5.upliveapp.com/zencms/5bd01326584fbb6c0aab5514.html">Terms & Conditions</a>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="head">
                                    <div className="text">
                                        <a href="http://h5.upliveapp.com/zencms/5bd010d4584fbb6c0aab5512.html">Privacy Policy</a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./js/orderview/channels/paytm/navbar.js